import { ExclamationCircleOutlined } from '@ant-design/icons';
import styled from 'styled-components';

export const WarningIconStyled = styled(ExclamationCircleOutlined)`
	svg {
		fill: #ff4d4f;
	}
`;
